/**
 * 数据转换工具函数
 *
 * @serverOnly false - 可在客户端和服务端使用
 */

/**
 * 对象转 FormData
 * @param obj - 要转换的对象
 * @returns FormData 对象
 */
export const objToForm = (obj: { [key: string]: unknown }): FormData => {
  const data = new FormData()
  Object.keys(obj).forEach((k) => {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      const value = obj[k]
      // 过滤 null 和 undefined，确保类型安全
      if (value !== null && value !== undefined) {
        data.append(k, String(value))
      }
    }
  })
  return data
}

/**
 * JSON 对象转 URL 查询字符串
 * @param json - 要转换的 JSON 对象
 * @returns URL 查询字符串，如 "key1=value1&key2=value2"
 */
export const jsonToForm = (json: { [key: string]: any }): string => {
  const str: string[] = []
  for (const k in json) {
    if (json[k]) {
      str.push(`${encodeURIComponent(k)}=${encodeURIComponent(json[k])}`)
    }
  }
  return str.join("&")
}
